var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['flex', 'flex-row', 'gap-x-1.5', 'items-center']},[_c(_setup.OzContainedButton,{class:[
      {
        'bg-dark-ui-200 text-light-text-100': _vm.backgroundLuminance === 'dark' && !_setup.whiteboardPlayModeStore.isPlayMode,
        'bg-light-ui-200 text-dark-text-100': _vm.backgroundLuminance === 'light' && !_setup.whiteboardPlayModeStore.isPlayMode,
      },
    ],attrs:{"title":_vm.__('Enter Draw mode'),"size-preset":_setup.OzContainedButtonSizePreset.H24px,"color-scheme":_setup.whiteboardPlayModeStore.isPlayMode
        ? _setup.OzContainedButtonColorScheme.SecondaryClear
        : _setup.OzContainedButtonColorScheme.Bare,"dark-mode":_vm.backgroundLuminance === 'dark'},on:{"click":_setup.exitPlayMode}},[_vm._v(_vm._s(_vm.__('Draw'))+"\n  ")]),_vm._v(" "),_c('span',{class:[
      'text-body-small',
      'select-none',
      {
        'text-dark-text-400': _vm.backgroundLuminance === 'light',
        'text-light-text-400': _vm.backgroundLuminance === 'dark',
      },
    ],attrs:{"aria-hidden":"true","tabindex":"-1"}},[_vm._v("\n    /\n  ")]),_vm._v(" "),_c(_setup.OzContainedButton,{class:[
      {
        'bg-dark-ui-200 text-light-text-100': _vm.backgroundLuminance === 'dark' && _setup.whiteboardPlayModeStore.isPlayMode,
        'bg-light-ui-200 text-dark-text-100': _vm.backgroundLuminance === 'light' && _setup.whiteboardPlayModeStore.isPlayMode,
      },
    ],attrs:{"title":_vm.__('Enter Play mode'),"size-preset":_setup.OzContainedButtonSizePreset.H24px,"color-scheme":!_setup.whiteboardPlayModeStore.isPlayMode
        ? _setup.OzContainedButtonColorScheme.SecondaryClear
        : _setup.OzContainedButtonColorScheme.Bare,"dark-mode":_vm.backgroundLuminance === 'dark'},on:{"click":_setup.enterPlayMode}},[_vm._v(_vm._s(_vm.__('Play'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }